// AI chat bubble preferences, persisted via vuex-persistedstate so the panel keeps the size the
// user dragged it to. null = the default size.
export default {
    namespaced: true,
    state: {
        panel_width: null,
        panel_height: null,
        // Set by the bubble once the API says this user has it (so other screens can offer it)
        available: false,
        // What this user's tools allow (edit, create, suppliers, history, supplier_history), from the API
        caps: {},
        // A message another screen asks the bubble to send (e.g. the Quality Control tab's
        // "Run QC in the assistant"); the bubble consumes and clears it.
        pending_request: null,
        // Bumped after the assistant changes data on a page with no aiRefresh() method: App.vue keys
        // the <router-view> on it, so the page is rebuilt and its created()/mounted() load again.
        page_reload_key: 0,
        // A quote the assistant drafted (draft_quote), waiting for the quote editor to load it on the
        // Review tab. Nothing is saved until the user presses Create / Update there.
        quote_draft: null,
        // Ids of users who have closed the bubble once. It opens by itself for a user until then, so a
        // user who is only given access later still gets the auto-open on their first sight of it.
        intro_seen_users: [],
    },
    mutations: {
        set_intro_seen(state, userId) {
            if (!state.intro_seen_users.includes(userId)) state.intro_seen_users.push(userId)
        },
        set_panel_size(state, { width, height }) {
            state.panel_width = width
            state.panel_height = height
        },
        set_available(state, value) {
            state.available = !!value
        },
        set_caps(state, caps) {
            state.caps = caps || {}
        },
        ask(state, request) {
            state.pending_request = { ...request, at: Date.now() }
        },
        clear_request(state) {
            state.pending_request = null
        },
        set_quote_draft(state, draft) {
            state.quote_draft = draft ? { ...draft, at: Date.now() } : null
        },
        reload_page(state) {
            state.page_reload_key = (state.page_reload_key || 0) + 1
        },
    },
    getters: {
        get_panel_size: state => ({ width: state.panel_width, height: state.panel_height }),
        is_available: state => state.available,
        get_caps: state => state.caps || {},
        get_pending_request: state => state.pending_request,
        is_intro_seen: state => userId => (state.intro_seen_users || []).includes(userId),
    },
}
